const cultural = [

  {
    id: "international-mother-language-day",
    date: "02-21",
    category: "culture",
    title: "International Mother Language Day",
    description: `International Mother Language Day promotes linguistic diversity and multilingual education. It encourages preservation of native languages and cultural heritage worldwide.`,
    color: "#7C3AED"
  },

  {
    id: "world-book-and-copyright-day",
    date: "04-23",
    category: "culture",
    title: "World Book and Copyright Day",
    description: `This day celebrates the power of books, authors, and reading. It highlights the importance of intellectual property rights and access to knowledge.`,
    color: "#1D4ED8"
  },

  {
    id: "international-day-of-cultural-diversity",
    date: "05-21",
    category: "culture",
    title: "World Day for Cultural Diversity",
    description: `This observance promotes intercultural dialogue and inclusion. It encourages respect for different traditions, languages, and artistic expressions.`,
    color: "#EC4899"
  },

  {
    id: "world-heritage-day",
    date: "04-18",
    category: "culture",
    title: "World Heritage Day",
    description: `World Heritage Day raises awareness about preserving cultural and natural heritage sites. It promotes global appreciation of shared human history.`,
    color: "#B45309"
  },

  {
    id: "international-day-of-the-worlds-indigenous-peoples",
    date: "08-09",
    category: "culture",
    title: "International Day of the World's Indigenous Peoples",
    description: `This day recognizes the traditions, languages, and rights of indigenous communities. It promotes inclusion and respect for cultural diversity.`,
    color: "#059669"
  }

];

export default cultural;